
    <a-center-popup [title]="'The Board Was Deleted'" (close)="onClosePopup()">
      <p>
        Someone deleted <b>{{boardName}}</b> board. You are not
        able to edit it anymore.
      </p>
      <button a-button class="btn_primary" (click)="onClosePopup()">OK</button>
    </a-center-popup>
  